import React, { useEffect, useState } from 'react';
import Router from './router';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga';
import { AppBanner } from './components';
import { TrackingService } from './utils/trackingService';
ReactGA.initialize('G-LCMH8Q1GTE');

// Simplified context for non-admin functionality (if needed)
interface IContextProps {
  email: string;
  setEmail: (email: string) => void;
}

export const AppContext = React.createContext<IContextProps>({
  email: '',
  setEmail: () => undefined
});

function App() {
  const [email, setEmail] = useState<string>('');
  const location = useLocation();

  // Track session started
  useEffect(() => {
    TrackingService.track('session_started');
    
    // Track session ended on beforeunload
    const handleSessionEnd = () => {
      TrackingService.track('session_ended');
    };
    
    window.addEventListener('beforeunload', handleSessionEnd);
    
    return () => {
      window.removeEventListener('beforeunload', handleSessionEnd);
    };
  }, []);

  useEffect(() => {
    console.log(location.pathname + location.search);
    ReactGA.pageview(location.pathname + location.search);
  }, [location]);

  return (
    <AppContext.Provider value={{ email, setEmail }}>
      <AppBanner currentPath={location.pathname} />
      <Router />
    </AppContext.Provider>
  );
}

export default App;
